@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../settings-page.module.less';
@import (reference) '../../../../constants/spacing.module.less';
@import './style-global.less';

.flex-fill-column {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.selected-store-page-header {
  padding: @settings-page--tabbed--header--title-only--padding;
}

.tabs-container {
  flex-grow: 1;
}

.tabs {
  max-height: 100%;
}

.tab-list {
  padding: @space-0 @space-24;
}

.selected-tab {
  background-color: @settings-page--tabbed--tab-panel--background-color;
}

.selected-tab-panel {
  background-color: @settings-page--tabbed--tab-panel--background-color;
  padding: @settings-page--tabbed--tab-panel--padding;
}

.loading-indicator {
  height: 500px;
}

.tab-header {
  margin-bottom: @space-24;
}

.warning-text {
  width: 70%;
  min-width: 400px;
  margin: 10px 0;
  // Global banner styles moved to style-global.less
}

.tab-title {
  // TODO: jv
  font-size: 28px;
  line-height: 32px;
  font-weight: 400;

  padding-bottom: 8px;
  margin: 0;
}

.sms-notification-header {
  display: flex;
  justify-content: flex-start;
}

// BEGIN: Styles for General Tab
.tab-content {
  display: flex;
  flex-direction: column;
  color: @settings-page--stores-settings--default--text-color;
  font-weight: @normal;

  h3 {
    // TODO: JV
    line-height: 25px;
    color: @settings-page--stores-settings--default--text-color;
    margin: 4px 0;
  }

  .container {
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
  }

  label {
    font-size: 16px;
    line-height: 18px;
    padding-bottom: 4px;
  }

  .flex-input {
    padding-top: 0;
  }

  .store-status-radio-checklist-item {
    padding: 0 0 4px;
  }

  .radio-checklist-item {
    padding: 0 0 8px;
  }

  .checkbox {
    font-size: 14px;
  }

  .note {
    font-size: 12px;
    line-height: 18px;
    color: @settings-page--stores-settings--note--text-color;
  }
}

.store-name {
  max-width: 400px;
}

.store-status-options-list {
  padding: 0;
  display: flex;
  justify-content: space-between;
  max-width: 175px;
}

.import-frequency-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .container {
    width: 45%;
  }
}

.insight-container {
  padding: 10px 30px 10px 10px;
  background: @insight--background--text-color;
  border-radius: 8px;
  max-width: 500px;

  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: @insight--title--text-color;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
  }

  .icon {
    margin-top: 3px;
  }

  .text {
    padding-left: 5px;
    color: @insight--default--text-color;
  }

  .content {
    font-weight: @normal;
    font-size: 14px;
    line-height: 20px;
    color: @settings-page--stores-settings--content--text-color;
    padding: 0;
  }

  .light-bulb-icon {
    height: 16px;
    width: 20px;
  }

  .redo-icon {
    height: 12px;
  }
}

.import-frequency-options-list {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.show-marketplace-settings {
  padding-top: 15px;

  h3 {
    margin-bottom: 12px;
  }
}

.save-settings-bar {
  padding-left: 44px;
}
// END: Styles for General Tab

.settings-disclaimer {
  font-size: 13px;
  padding: 5px 0 0;
  color: @settings-page--stores-selected-settings--text-color;
}

.grid-form {
  display: grid;
  max-width: 956px;
  grid-template-columns: 200px auto;
  row-gap: 15px;

  .input-label {
    padding: 0 15px;
    align-self: center;
  }

  .multi-line-label {
    align-self: flex-start;
    padding: 10px 15px;
  }

  .sub-checkbox {
    margin-top: 10px;
  }

  .input-element {
    width: 100%;

    .checkbox {
      font-size: 14px;
    }

    .toggler {
      min-width: 250px;
    }

    .store-logo-drop {
      border: 2px dashed @settings-page--stores-selected--border-color;
      border-radius: 10px;
      min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 14px;
      cursor: pointer;

      &.error {
        border: 1px solid @settings-page--stores-selected--error--border-color;
      }
      &.warning {
        border: 1px solid @settings-page--stores-selected--warning--border-color;
      }

      .upload-a-file {
        display: flex;
        color: @settings-page--stores-selected-upload--text-color;
      }

      .hidden-file-input {
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0;
      }

      .helper-sentence {
        font-size: 14px;
        width: 75%;
        margin-top: 16px;
        text-align: center;
        color: @settings-page--stores-selected-settings--text-color;
      }
    }

    .image-wrapper {
      border: 1px solid @settings-page--stores-selected-image--border-color;
      padding: 12px 10px;
      border-radius: 4px;

      .image-element {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }
    }
  }
}

.setting-description {
  font-size: 12px;
  line-height: 16px;
  padding-top: 0;
  color: @settings-page--stores-selected-settings--text-color;
}

.radio-wrapper {
  padding: 0 15px;

  .radio-checklist {
    display: flex;
    flex-direction: column;
  }

  .radio-content-disabled {
    display: flex;
    gap: 8px;
  }
}

.product-setting {
  padding: 5px @space-0;

  .product-setting-header h2 {
    margin: 0;
  }

  .product-setting-radio {
    margin-left: 25px;
    display: flex;
    > div {
      padding: 10px 5px;
    }
  }

  .product-setting-content {
    margin-left: 25px;
    padding: 10px 0;
  }
}

.tracking-page {
  padding-bottom: 16px;
  line-height: 1.5;
  max-width: 800px;
}

.shipping-services-body {
  max-width: 800px;
}

.add-service-mapping-button {
  display: block;
  margin-left: auto;
}

.table-loading-indicator {
  height: 300px;
}

.service-mapping-grid {
  max-width: 900px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: auto auto auto auto;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;

  .service-header-cell {
    background-color: @settings-page--table--header--cell--background-color;
    padding: @settings-page--table--cell--padding;
    border-top: @settings-page--table--border;
    border-bottom: @settings-page--table--border;
    color: @settings-page--table--header--cell--text-color;
  }

  .service-header-cell:first-child {
    border-left: @settings-page--table--border;
  }

  .service-header-cell-right {
    .service-header-cell();
    border-right: @settings-page--table--border;
    text-align: center;
  }

  .grid-cell {
    min-height: 45px;
    padding: @settings-page--table--cell--padding;
    border-bottom: @settings-page--table--border;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .left-grid-cell {
    .grid-cell();
    border-left: @settings-page--table--border;
  }

  .right-grid-cell {
    .grid-cell();
    border-right: @settings-page--table--border;
    flex-direction: row;
    justify-content: space-evenly;

    button {
      padding: 0 10px;
    }
  }
}

.activity-table {
  border: @settings-page--table--border;
  border-radius: 4px;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  .header {
    background-color: @settings-page--table--header--cell--background-color;
    border-bottom: @settings-page--table--border;
    color: @settings-page--table--header--cell--text-color;
    padding: @settings-page--table--cell--padding;
    font-weight: @settings-page--table--header--cell--font-weight;
  }

  .instance {
    padding: @settings-page--table--cell--padding;
    border-bottom: 1px solid @settings-page--table--border-color;
    display: flex;
    flex-direction: column;

    .instance-line {
      padding: 5px;
      display: flex;
      align-items: center;

      .time {
        padding-right: 5px;
        display: flex;
        align-items: center;

        .clock-icon {
          height: 16px;
          width: 16px;
        }

        span {
          padding: 0 5px;
        }
      }

      .by {
        margin-right: 5px;
      }

      .person-icon {
        height: 12px;
        width: 12px;
        margin-right: 5px;
      }
    }

    .bottom-instance-line {
      .instance-line();
      padding-left: 30px;
    }
  }

  .load-more {
    margin: 15px 10px;
  }
}

.modal {
  width: 750px;
  height: 475px;
}

.body {
  height: 100%;
  width: 100%;
  padding: 20px;

  .style.descriptor {
    line-height: 1.5;
  }

  .green-text {
    color: @settings-page--stores-selected-green--text-color;
  }

  .service-key {
    margin-top: 25px;
  }

  .fill-method {
    display: flex;
    font-size: 14px;
    align-items: center;

    label {
      flex: 1;
      text-align: right;
      padding-right: 15px;
    }

    .radio-fill-method {
      flex: 3;
      display: flex;
      flex-direction: row;
      padding: 0 10px;
    }
  }

  .service-mapping-box {
    border: 1px solid @settings-page--stores-selected--border-color;
    border-radius: 4px;
    margin: 20px 0;

    .service-mapping-title {
      padding: 15px;
      border-bottom: 1px solid @settings-page--stores-selected--border-color;
      background-color: @settings-page--stores-selected-service--background-color;
    }

    .service-mapping-dropdown-container {
      display: grid;
      grid-template-columns: 284px auto;
      column-gap: @space-8;
      padding: @space-8;

      label {
        text-align: right;
        align-self: center;
      }

      .service-mapping-dropdown {
        border: 1px solid @settings-page--stores-selected-dropdown--border-color;
        border-radius: 4px;
        min-width: 400px;
        background-color: @settings-page--stores-selected-dropdown--background-color;
        font-size: 14px;
        color: @settings-page--stores-selected-dropdown--text-color;
      }

      .fulfillment-mapping-dropdown {
        min-width: 400px;
        background-color: @settings-page--stores-selected-dropdown--background-color;
        font-size: 14px;
        color: @settings-page--stores-selected-dropdown--text-color;
      }

      .service-mapping-toggler {
        width: 100%;
      }
    }
  }
}

.loading {
  height: 100%;
  width: 100%;
}

.content {
  height: 100%;
  width: 100%;
}

.packing-slips {
  .input-label {
    &.error {
      color: @settings-page--stores-selected--error--text-color;
    }
  }

  .toggler {
    &.error {
      border: 1px solid @settings-page--stores-selected--error--border-color;
    }
  }
  .field-required-error {
    background-color: @settings-page--stores-selected-field--error--background-color;
    font-size: 12px;
    width: 250px;
    display: flex;
    align-items: center;

    .error-icon {
      height: 16px;
      width: 16px;
      color: @settings-page--stores-selected--error--text-color;
      margin: 5px;
    }
  }
}

.sub-field {
  display: flex;
  align-items: center;
  padding: 5px 20px;

  .sub-input {
    border: 1px solid @settings-page--stores-selected-input--border-color;
    border-radius: 5px;
    padding-right: 0;
    background-color: @settings-page--stores-selected-input--background-color;
    font-size: 12px;
    width: 75px;
    align-items: center;
  }

  .sub-input-description {
    font-size: 12px;
    padding: 5px 20px;
  }
}

.untrackable-header {
  margin: 15px 0 10px;
}

.conditions {
  padding-left: 20px;
}

.checkbox {
  margin: 5px;
}

.checkbox-note {
  padding-left: @space-28;
}

.beta-tag-container {
  display: flex;
}

.email-intro p {
  margin-bottom: 16px;
}
.email-settings-container {
  max-width: 686px;

  h2 {
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    margin: 24px 0;
  }
}
.email-settings-container.checkboxes {
  .email-settings-content {
    padding-left: 24px;
  }
}

.email-settings-section {
  font-size: 16px;
  margin-bottom: @space-24;
  max-width: 466px;

  .settings-header {
    justify-content: space-between;
  }

  h3 {
    display: flex;
    font-size: 16px;
    line-height: 24px;
    flex-grow: 1;
    font-weight: 400;
    margin: 0 0 8px;
  }
}

.email-settings-content {
  .input-element {
    .dropdown {
      width: 100%;
      margin-bottom: 12px;
    }
    .toggler {
      min-width: 450px;
    }
  }
}

.shipment-notification-configuration {
  margin: 16px 0;
  font-size: 14px;
  line-height: 24px;
}

.trigger-checkbox {
  width: 24px;
  padding: 5px 0 0 2px;
}

.description-spacer {
  margin-top: 12px;
}

.branded-emails-tab__heading-container {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.branded-emails-tab__heading {
  margin: 0 0 16px;
}
